export const questionnareErrorInitial = {
    name: false,
    minimumEligibilityPoint: false,
    objectiveQuestions: [],
    points: false
}